import { styled } from '@mui/material/styles';
import { Pagination as OutLinedPagination } from '@mui/material';

const Root = styled('div')(({ theme }) => ({
  justifyContent: 'center',
  display: 'flex',
  alignItems: 'flex-start',

  flexWrap: 'nowrap',
  maxWidth: 600,
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: theme.spacing(5),
  marginBottom: theme.spacing(6),
  disableRipple: true,
  ul: {
    '& .MuiPaginationItem-root': {
      color: 'white',
      borderColor: 'transparent',
      '&.Mui-selected': {
        background: 'transparent',
        borderColor: 'white',
        color: 'white',
      },
    },
  },
}));

type PaginationProps = {
  pages: number;
  currentPage: number;
  onClick: (page: number) => void;
};

const Pagination: React.FC<PaginationProps> = ({ currentPage, onClick, pages }) => {
  return (
    <Root>
      <OutLinedPagination
        count={pages}
        siblingCount={1}
        variant="outlined"
        page={currentPage}
        sx={{ ml: 2, minWidth: 40 }}
        onChange={(e, value) => onClick(value)}
      />
    </Root>
  );
};

export default Pagination;
